import { render } from "./BagIcon.vue?vue&type=template&id=d0bc42b2&scoped=true"
import script from "./BagIcon.vue?vue&type=script&lang=js"
export * from "./BagIcon.vue?vue&type=script&lang=js"

import "./BagIcon.vue?vue&type=style&index=0&id=d0bc42b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0bc42b2"]])

export default __exports__